<template>
    <div class="container">
        <div class="row breadcrumb-row">
            <nav>
                <div class="nav-wrapper">
                    <div class="col s12">
                        <a :href="homeUrl" class="breadcrumb">Home</a>
                        <a :href="productUrl" class="breadcrumb">CNY Rewards</a>
                    </div>
                </div>
            </nav>
        </div>
        <div class="row">
            <div class="col s12 m3">
                <h5 class="product-page-title">SHOP BY</h5>
                <div class="row">
                    <div class="col s12">
                        <p class="product-page-subtitle">CATEGORY</p>
                        <ul>
                            <li v-for="category in campaign_product_categories" v-if="category.product_count > 0">
                                <p>
                                    <label>
                                        <input type="checkbox" :value="category.id" v-model="category_ids" class="filled-in"/>
                                        <span>{{ category.name }}</span>
                                    </label>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col s12 m9">
                <div class="row">
                    <div class="col s6 m6 l3" v-for="product in campaign_products">
                        <a v-bind:href="product.product_url">
                            <div class="card product-card hoverable">
                                <div class="card-image">
                                    <img v-bind:src="product.product_image_url">
                                </div>
                                <div class="card-content">
                                    <div class="product-title">{{ product.name | truncate(40, '...') }}</div>
                                    <div class="point">{{ product.points | numberComma }} pts</div>
                                    <!--<div class="original-price grey-text">500,000 points</div>-->
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row" v-if="campaign_products.length == 0 && !is_loading">
                    <div class="col s12 center-align">
                        No Product Available
                    </div>
                </div>
                <div class="row">
                    <div class="col s12 m8 l9" v-if="is_loading">
                        <div class="row">
                            <div class="col s12 center-align">
                                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true" style="font-size: 2.5rem;"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductListComponent",
        props: [
            'exampleImageUrl',
            'getAllProductsUrl',
            'getAllProductCategoriesUrl',
            'homeUrl',
            'productUrl'
        ],
        data() {
            return {
                campaign_products: [],
                campaign_product_categories: [],
                category_ids: [],
                is_loading: false
            }
        },
        watch: {
            category_ids: function(newValue) {
                let me = this;
                this.campaign_products = [];
                this.is_loading = true;
                axios.get(this.getAllProductsUrl, {
                    params: {
                        ids: this.category_ids
                    }
                }).then(function (response) {
                    me.campaign_products = response.data.campaign_products;
                    me.is_loading = false;
                }).catch(function (error){

                })
            }
        },
        created () {
            let product_category_id = new URL(location.href).searchParams.get('id');

            if (product_category_id)
            {
                this.category_ids.push(product_category_id);
            }
        },
        mounted () {
            this.getProducts();
            this.getProductCategories();
        },
        methods: {
            getProducts ()
            {
                let me = this;
                me.is_loading = true;
                axios.get(this.getAllProductsUrl)
                    .then(function (response) {
                        me.campaign_products = response.data.campaign_products;
                        me.is_loading = false;
                    })
                    .catch(function (error){

                    });
            },
            getProductCategories ()
            {
                let me = this;
                axios.get(this.getAllProductCategoriesUrl)
                    .then(function (response) {
                        me.campaign_product_categories = response.data.campaign_product_categories;
                    })
                    .catch(function (error){

                    });
            }
        }
    }
</script>

<style scoped>

</style>